<template>
  <component :is="BaseSingleTemplate" v-if="episode">
    <template #template-label>
      <Label name="episode" />
    </template>
    <template #share-button>
      <ShareButton />
    </template>
    <template #main-image>
      <ShowCarousel v-if="episodePhotos.length" :images="episodePhotos" />
      <picture v-else>
        <img
          :class="isMainImageLoaded ? 'fade-in-fast' : 'd-none'"
          :src="$router.options.imagePath + episode.mediaUrl"
          @load="isMainImageLoaded = true"
        />
      </picture>
    </template>
    <template #data-info>
      <div class="data-info-container__header">
        <div
          class="data-info-container__header__item data-info-container__header__item--episode-left"
        >
          <div class="data-info-container__header__item__date">
            {{ sqlDateFormatted }} —
            <router-link :to="{name: 'location-id-episodes', params: {id: episode.location.locationname}}">
              {{ episode.location.locationname }}
            </router-link>
          </div>
          <h1 class="data-info-container__heading">
            {{ episode.title }}
          </h1>
          <div class="data-info-container__subheading-container">
            <div class="data-info-container__subheading-container__item">
              <div
                v-if="episode.mainArtist.mainPodcast"
                class="data-info-container__subheading-container__col"
              >
                <span>HOST ON MONTHLY SHOW</span>
                <router-link
                  :to="{
                    name: 'Podcasts',
                    params: { id: episode.podcast.permlink }
                  }"
                >
                  {{ episode.podcast.name }}
                </router-link>
              </div>
              <div class="data-info-container__subheading-container__col">
                <span> {{ getArtistType }}</span>
                <router-link
                  :to="{
                    name: 'Artist',
                    params: { id: episode.mainArtist.permlink }
                  }"
                >
                  {{ episode.mainArtist.name }}
                </router-link>
              </div>
              <div
                v-if="episode.artists.length"
                class="data-info-container__subheading-container__col"
              >
                <span>WITH GUESTS</span>

                <router-link
                  v-for="guest in episode.artists"
                  :key="guest.id"
                  :to="{
                    name: 'Artist',
                    params: { id: guest.permlink }
                  }"
                >
                  {{ guest.name }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="data-info-container__header__item">
          <EpisodeButton
            class-name="black-circle"
            :episode-title="episode.title"
            :episode-url="episode.showurl"
            :episode-permlink="episode.permlink"
            :artist="episode.mainArtist"
            :podcast="episode.podcast"
            :provider="episode.episodeProvider"
            :soundcloud-url="episode.soundcloudUrl"
          />
        </div>
      </div>
      <h4 class="data-info-container__subheading">
        EPISODE DESCRIPTION
      </h4>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="data-info-container__content" v-html="episode.info" />
      <div class="genres-list">
        <div class="genres-list__inner">
          <ul v-if="episode.subGenres.length && $store.getters.getGenresState" class="genres-list__inner__list">
            <li v-for="genre in episode.subGenres" :key="genre.id"
                class="genres-list__inner__list__item">
              <GenreButton :genre="genre"/>
            </li>
          </ul>
          <div class="genres-list__inner__button">
            <ShareFacebook />
          </div>
        </div>
      </div>
    </template>
    <template v-if="episode.tracklist" #tracklist>
      <div class="single-tracklist-container">
        <div class="single-tracklist-container__inner">
          <EpisodeTracklistSection :track-list="episode.tracklist" />
        </div>
      </div>
    </template>
    <template v-if="episode.mainArtist.artistType === 'Resident'" #artist-section>
      <div class="artist-section-container">
        <div class="artist-section-container__inner">
          <EpisodeArtistSection :main-artist="episode" />
        </div>
      </div>
    </template>
    <template v-if="latestEpisodes.length" #related-section>
      <div class="related-section">
        <div class="related-section__header">
          <div class="related-section__header__title">
            PREVIOUS EPISODES
          </div>
          <router-link
            :to="{
              name: 'Artist',
              params: { id: episode.mainArtist.permlink }
            }"
            class="related-section__header__link"
          >
            view all
          </router-link>
        </div>
        <SimilarCarousel>
          <div v-for="latestEpisode in latestEpisodes"
               :key="latestEpisode.id"
               class="swiper-slide"
          >
            <EpisodeCard :episode="latestEpisode" :artist="latestEpisode.mainArtist" />
          </div>
        </SimilarCarousel>
      </div>
    </template>
  </component>
</template>
<script>
import axios from 'axios';
import EpisodeButton from '@/components/ui/EpisodeButton.vue';
import BaseSingleTemplate from '@/components/BaseSingleTemplate';
import Label from '@/components/Label.vue';
import ShareButton from '@/components/ui/ShareButton.vue';
import ShareFacebook from '@/components/ui/ShareFacebook.vue';
import EpisodeCard from '@/components/cards/EpisodeCard.vue';
import EpisodeArtistSection from '@/components/sections/EpisodeArtistSection.vue';
import EpisodeTracklistSection from '@/components/sections/EpisodeTracklistSection.vue';
import SimilarCarousel from '@/components/sections/SimilarCarousel.vue';
import ShowCarousel from "@/components/sections/ShowCarousel.vue";
import GenreButton from "@/components/genres/GenreButton";

export default {
  name: 'EpisodeSingle',
  components: {
    BaseSingleTemplate,
    Label,
    ShareButton,
    EpisodeButton,
    ShareFacebook,
    EpisodeCard,
    EpisodeArtistSection,
    EpisodeTracklistSection,
    SimilarCarousel,
    ShowCarousel,
    GenreButton,

  },
  data() {
    return {
      episode: null,
      latestEpisodes: [],
      episodePhotos: [],
      BaseSingleTemplate: BaseSingleTemplate,
      isMainImageLoaded: false
    };
  },

  computed: {
    sqlDateFormatted() {
      return this.episode.sqlDate
        .split('-')
        .reverse()
        .join('.');
    },
    getArtistType() {
      return this.episode.mainArtist.artistType === 'Resident' ? 'WITH RESIDENT' : 'WITH GUEST';
    }
  },

  created() {
    this.getEpisode();
  },

  methods: {
    getEpisode() {
      axios
        .get(this.$router.options.api + '/episode/perm/' + this.$route.params.id)
        .then(response => {
          this.episode = response.data;
          // check if episode description has HTML elements
          this.episodeInfoHasHTML(response.data.info);
          this.getLatestEpisodes(response.data.mainArtist.id);
          if (response.data.episodePhotos.length > 0) {
            const featuredPhoto = {
              id: Math.floor(Math.random() * response.data.id),
              urlMedia: response.data.mediaUrl,
              sorted: 0
            }
            this.episodePhotos = [featuredPhoto, ...response.data.episodePhotos].sort((a, b) => a.sorted - b.sorted);
          }

        })
        .catch(error => {
          console.error(error);
        });
    },

    getLatestEpisodes(mainArtistId) {
      axios
        .get(`${this.$router.options.api}/episode/artist/${mainArtistId}?size=5&&page=0`)
        .then(response => {
          // Filter out the current episode from the latest list
          this.latestEpisodes = response.data.content.filter(
            e => e.permlink !== this.$route.params.id
          );
        });
    },
    episodeInfoHasHTML(episodeText) {
      const containsHTML = text => /<[a-z][\s\S]*>/i.test(text);
      const addParagraph = value => {
        if (!value) return '';
        return value.replace(/(\r\n|\n|\r)/gm, '<br/>');
      };
      const isHTML = containsHTML(episodeText);
      if (!isHTML) this.episode.info = addParagraph(episodeText);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
@import '@/assets/sass/pages/_episode-single.scss';
</style>
